import React from "react";
const IconClear = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20" {...props}>
    <path
      d="M19.1 4v12a1 1 0 0 1-1 1H5.66a1 1 0 0 1-.86-.5l-3.43-6a1 1 0 0 1 0-1l3.43-6a1 1 0 0 1 .86-.5H18.1a1 1 0 0 1 1 1Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path d="m8.25 6.16 7.68 7.68m0-7.68-7.68 7.68" stroke="currentColor" strokeWidth="2" />
  </svg>
);
export default IconClear;
